import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import PaletteIcon from '@mui/icons-material/Palette';
import AppearanceControls from './AppearanceControls';

export default function EditorSettingsDrawer({
  open,
  file,
  onClose,
  onAppearanceChange,
  onAppearanceReset,
  onMove,
  onDelete,
  onDownload,
}) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: { xs: '100vw', sm: 380 }, p: 2.5 }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 2 }}>
          <PaletteIcon color="primary" />
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography variant="h6" fontWeight={800} noWrap>
              Appearance
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {file?.name}
            </Typography>
          </Box>
          <IconButton aria-label="Close settings" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>

        {file ? (
          <AppearanceControls
            appearance={file.appearance}
            onChange={onAppearanceChange}
            onReset={onAppearanceReset}
          />
        ) : null}

        <Divider sx={{ my: 3 }} />

        <Stack spacing={1.25}>
          <Button startIcon={<DriveFileMoveIcon />} variant="outlined" onClick={onMove}>
            Move
          </Button>
          <Button startIcon={<DownloadIcon />} variant="outlined" onClick={onDownload}>
            Download
          </Button>
          <Button startIcon={<DeleteIcon />} variant="contained" color="error" onClick={onDelete}>
            Delete
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
}
